export default class ApiKey {
  constructor() {
    this.id = null
    this.secret = ''
  }

  mutations() {
    return {
      setApiKey: (state, key) => state.apiKey = key
    }
  }
}